import { useMemo } from 'react'
import { type Product } from 'domains/products/components/view/utils/types'
import { useDomainMessages } from 'domains/products/utils/domain/intl'

export const useProductAttributes = (product: Product): string => {
  const messages = useDomainMessages({
    glutenFree: 'productsDomain.view.details.sections.attributes.glutenFree',
    lowFat: 'productsDomain.view.details.sections.attributes.lowFat',
    alcoholic: 'productsDomain.view.details.sections.attributes.alcoholic',
    kosher: 'productsDomain.view.details.sections.attributes.kosher',
    organic: 'productsDomain.view.details.sections.attributes.organic',
    vegan: 'productsDomain.view.details.sections.attributes.vegan',
    sugarFree: 'productsDomain.view.details.sections.attributes.sugarFree',
    vegetarian: 'productsDomain.view.details.sections.attributes.vegetarian',
  })

  return useMemo(() => {
    if (!product) return null

    return (
      Object.entries({
        glutenFree: product.glutenFree,
        lowFat: product.lowFat,
        alcoholic: product.alcoholic,
        kosher: product.kosher,
        organic: product.organic,
        vegan: product.vegan,
        sugarFree: product.sugarFree,
        vegetarian: product.vegetarian,
      } as Record<keyof typeof messages, boolean>)
        .reduce<string[]>((result, [key, selected]) => {
          if (selected) result.push(messages[key])

          return result
        }, [])
        .join(', ') || null
    )
  }, [product, messages])
}
